module.exports = __webpack_public_path__ + "images/ff9c78146a008ebfa65ef34318b35718.png";